import { FetchError } from "../typings";

export async function fetchService<T>(
    url: string,
    options: RequestInit = {},
    retries: number = 3,
    timeout = 15000,
    delay: number = 1000
  ): Promise<Response> {
    function fetchWithTimeout<T>(url:string, options = {}): Promise<Response>  { 
      const controller = new AbortController(); 
      const { signal } = controller; 
      const fetchOptions = { ...options, signal }; 
      // Start the fetch request
       const fetchPromise = fetch(url, fetchOptions); 
       // Set up the timeout 
       const timeoutPromise = new Promise((_, reject) => 
       setTimeout(() => { controller.abort(); 
        reject(new Error('Request timed out')); }, 
        timeout) ); 
        // Return a race between the fetch and the timeout 
        return Promise.race([fetchPromise, timeoutPromise]) as Promise<Response>; 
      }
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const response = await fetchWithTimeout(url, options);
        
        if (!response.ok) {
          const errorData = await response.json();
          const errorObj:FetchError = {errorType: "API error",response: response,details: `${response.status} 
          ${response.statusText}. Message: ${errorData.message || 'Unknown error'}`}
          throw new Error("API error",{cause: errorObj});
        }
  
        return  response;
      } catch (error: any) {
        console.log(error)
        if (attempt === retries) {
          if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
            const errorObj:FetchError = navigator.onLine ? 
            {errorType: "API error",details: `${error.name} . Message: ${error.message || 'Unknown error'}`}:
           {errorType: "Network error",details: `${error.name} . Message: ${error.message || 'Unknown error'}`}
            throw new Error(error.name,{cause: errorObj});
          }
          throw error;
        } else {
          await new Promise(res => setTimeout(res, delay));
        }
      }
    }
    // Fallback return in case all retries fail (shouldn't reach this point)
    const errorObj:FetchError = {errorType: "Unexpected error",details: `Unexpected error . Message: All retries failed`}         
    throw new Error("Unexpected error",{cause: errorObj});
  }
  